import React, { useState } from "react";
import logo from "../../assets/center_all_pic/AceLOGO.png";
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Container,
  Stack,
  Popover,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  Button,
  Link,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";
import GalleryIcon from "@mui/icons-material/PhotoLibrary"; // Example icon
import EventIcon from "@mui/icons-material/Event"; // Example icon
import ContactsIcon from "@mui/icons-material/Contacts";
import LoginIcon from "@mui/icons-material/Login"; // Example icon
import GroupIcon from "@mui/icons-material/Group"; // Example icon
import { useNavigate, useLocation } from "react-router-dom";

const pages = [
  { name: "Home", routelink: "/" },
  { name: "Courses", routelink: "/courses" },
  { name: "Blogs", routelink: "/blogs" },
  { name: "About", routelink: "/about" },
  { name: "More", routelink: "#" }, // More link for popover
];

const blogPosts = [
  {
    title: "Latest Blog 1",
    image: "",
    description: "This is a description for blog post 1.",
  },
  {
    title: "Latest Blog 2",
    image: "",
    description: "This is a description for blog post 2.",
  },
];

const ResponsiveAppBar = () => {
  const navigate = useNavigate();
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElPopover, setAnchorElPopover] = useState(null);
  const theme = useTheme();
  const location = useLocation();
  const currentPath = location.pathname;
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // true for xs/sm

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = (routelink) => {
    setAnchorElNav(null);
    if (routelink !== "#") navigate(routelink);
  };

  const handleOpenPopover = (event) => {
    setAnchorElPopover(event.currentTarget);
  };

  const handleClosePopover = () => {
    setAnchorElPopover(null);
  };

  const popoverOpen = Boolean(anchorElPopover);

  return (
    <AppBar
      position="sticky"
      sx={{
        bgcolor: "rgba(229, 224, 224, 0.51)",
        backdropFilter: "blur(15px)",
        borderRadius: "0 0 32px 32px", // Rounded top corners to match design
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        color: "black",
        fontWeight: "bold",
      }}
      elevation={0}
    >
      <Container maxWidth="xl" m="2">
        <Toolbar disableGutters>
          <Box
            component="img"
            src={logo}
            alt="Logo"
            sx={{
              display: { xs: "flex", sm: "flex", md: "flex" },
              mr: 1,
              height: { xs: 30, sm: 30, md: 30 }, // Set height or width as needed
            }}
          />

          {/* <AdbIcon sx={{ display: { xs: "flex", md: "none" }, mr: 1 }} /> */}
          <Box
            sx={{
              display: { xs: "none", sm: "none", md: "flex" },
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              // py: { xs: 2, md: 4 },
            }}
          >
            {/* <Typography
              variant="h5"
              component="h4"
              sx={{
                fontWeight: 900,
                letterSpacing: { xs: ".15rem", md: ".45rem" },
                color: "inherit",
                mb: -1,
                // fontSize: { xs: "2rem", sm: "3rem", md: "3.5rem" },
                textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
              }}
            >
              AASTHA
            </Typography>

            <Typography
              variant="h6"
              component="h5"
              sx={{
                // fontWeight: 700,
                color: "#222",
                // fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" },
                letterSpacing: ".2rem",
              }}
            >
              COMPUTERS
            </Typography> */}
            <Typography
              variant="h6"
              component="h6"
              sx={{
                // color: "#90caf9",
                fontSize: { xs: "1.5rem" },
                fontWeight: 700,
                textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
                cursor: "pointer",
              }}
            >
              Aastha Computers
            </Typography>
          </Box>

          {/* Mobile humburger menu with pages designed */}
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "flex", md: "none", sm: "none" },
            }}
          >
            <IconButton
              size="large"
              aria-label="open navigation menu"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              keepMounted
              transformOrigin={{ vertical: "top", horizontal: "left" }}
              open={Boolean(anchorElNav)}
              onClose={() => handleCloseNavMenu(null)}
              sx={{ display: { xs: "block", md: "none" } }}
            >
              {pages.map((page, index) => (
                <MenuItem
                  key={index}
                  selected={page.routelink === currentPath}
                  onClick={
                    page.name === "More"
                      ? handleOpenPopover
                      : () => handleCloseNavMenu(page.routelink)
                  }
                >
                  <Typography
                    textAlign="center"
                    sx={{
                      fontWeight:
                        page.routelink === currentPath ? "bold" : "normal",
                      color:
                        page.routelink === currentPath
                          ? "primary.main"
                          : "inherit",
                    }}
                  >
                    {page.name}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          {/* Desktop humburger menu with pages designed */}
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "none", md: "flex", sm: "flex" },
              justifyContent: "center",
              gap: { md: "1rem" },
            }}
          >
            {pages.map((page, index) => (
              <Button
                key={index}
                onClick={
                  page.name === "More"
                    ? handleOpenPopover
                    : () => handleCloseNavMenu(page.routelink)
                }
                sx={{
                  my: 2,
                  color:
                    page.routelink === currentPath ? "primary.main" : "black",
                  fontWeight:
                    page.routelink === currentPath ? "bold" : "normal",
                  borderBottom:
                    page.routelink === currentPath ? "2px solid" : "none",
                  borderColor:
                    page.routelink === currentPath
                      ? "primary.main"
                      : "transparent",
                  display: "block",
                  borderRadius: 0,
                }}
              >
                {page.name}
              </Button>
            ))}
          </Box>

          <Stack spacing={2} direction="row">
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "row", sm: "row" },
                gap: 1,
                alignItems: "center",
              }}
            >
              {isMobile ? (
                <IconButton
                  onClick={() => navigate("/login")}
                  sx={{ color: "black" }}
                  aria-label="Login"
                >
                  <LoginOutlinedIcon />
                </IconButton>
              ) : (
                <Button
                  variant="outlined"
                  sx={{
                    borderColor: "black",
                    color: "black",
                    borderRadius: "22px",
                  }}
                  onClick={() => navigate("/login")}
                >
                  Login
                </Button>
              )}

              <Button
                variant="contained"
                sx={{
                  bgcolor: "black",
                  "&:hover": { bgcolor: "grey.800" },
                  width: { xs: "100%", sm: "auto" },
                  borderRadius: "22px",
                }}
                onClick={() => navigate("/admission")}
              >
                Get Started
              </Button>
            </Box>
          </Stack>
        </Toolbar>
      </Container>

      <Popover
        className="popover-sit"
        open={popoverOpen}
        anchorEl={anchorElPopover}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: "bottom",
          // horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        PaperProps={{ sx: { width: "70%", borderRadius: "16px !important" } }} // Increased width and height
      >
        <Box sx={{ p: 2, display: "flex", flexDirection: "column", margin: 2 }}>
          <Grid
            container
            spacing={2}
            sx={{
              flexDirection: { xs: "column", md: "row", sm: "row" },
            }}
          >
            {/* Left Side - Additional Pages */}
            <Grid md={6} sm={12} container spacing={2} sx={{ flexGrow: 1 }}>
              <Grid item xs={6}>
                <Typography variant="h6" gutterBottom>
                  More Pages
                </Typography>
                <List>
                  <ListItem onClick={() => navigate("/gallery")}>
                    <ListItemIcon sx={{ minWidth: "32px !important" }}>
                      <GalleryIcon sx={{ color: "#333" }} />
                    </ListItemIcon>
                    <Typography>Gallery</Typography>
                  </ListItem>
                  <ListItem onClick={() => navigate("/events")}>
                    <ListItemIcon sx={{ minWidth: "32px !important" }}>
                      <EventIcon sx={{ color: "#333" }} />
                    </ListItemIcon>
                    <Typography>Events</Typography>
                  </ListItem>
                  <ListItem onClick={() => navigate("/contact")}>
                    <ListItemIcon sx={{ minWidth: "32px !important" }}>
                      <ContactsIcon sx={{ color: "#333" }} />
                    </ListItemIcon>
                    <Typography>Contact</Typography>
                  </ListItem>
                </List>
              </Grid>
              <Divider sx={{ my: 2 }} />
              <Grid item xs={6}>
                <Typography variant="h6" gutterBottom>
                  Logins
                </Typography>
                <List>
                  <ListItem onClick={() => navigate("/login")}>
                    <ListItemIcon sx={{ minWidth: "32px !important" }}>
                      <LoginIcon sx={{ color: "#333" }} />
                    </ListItemIcon>
                    <Typography>SSO</Typography>
                  </ListItem>
                  <ListItem onClick={() => navigate("/login")}>
                    <ListItemIcon sx={{ minWidth: "32px !important" }}>
                      <GroupIcon sx={{ color: "#333" }} />
                    </ListItemIcon>
                    <Typography>Student</Typography>
                  </ListItem>
                </List>
              </Grid>
            </Grid>

            {/* Right Side - Blog Posts */}
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                bgcolor: "#f9f9f9",
                borderRadius: 2,
                paddingY: "0 !important",
                paddingX: { xs: "16px", md: 2 }, // Responsive padding for small and medium+ screens
              }}
            >
              <Typography variant="h6" gutterBottom sx={{ mt: "0.5rem" }}>
                Latest Blog Posts
              </Typography>
              {blogPosts.length > 0 ? (
                <Grid
                  container
                  spacing={2}
                  sx={{
                    flexDirection: { xs: "column", md: "row" }, // Column for small screens, row for medium and up
                    flexWrap: "wrap",
                    justifyContent: "space-between",
                  }}
                >
                  {/* Loop through blogPosts array */}
                  {blogPosts.map((post, index) => (
                    <Grid
                      key={index}
                      item
                      xs={12}
                      md={index === 0 ? 12 : 12} // Full width for the first post, half width for others on medium screens
                      sx={{
                        mb: 2, // Margin bottom for better spacing
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        textAlign: "center",
                      }}
                    >
                      <Card
                        className="CardForBlog"
                        sx={{
                          width: { xs: "40vw", md: "20vw" }, // Responsive width: larger on smaller screens
                          height: { xs: "30vh", md: "20vh" }, // Responsive height
                          borderRadius: 2,
                          boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1)",
                          overflow: "hidden",
                          transition: "transform 0.3s ease-in-out",
                          "&:hover": {
                            transform: "scale(1.05)",
                          },
                          cursor: "pointer",
                        }}
                      >
                        <CardMedia
                          component="img"
                          height="100%"
                          className="cardImage"
                          image={post.image}
                          alt={post.title}
                        />
                        {/* <CardContent sx={{ paddingLeft: { xs: 2, md: 3 }, display:{xs:'block', sm:'none'} }}>
        <Typography variant="h6">{post.title}</Typography>
        <Typography variant="body2" color="text.secondary">
          {post.description}
        </Typography>
      </CardContent> */}
                      </Card>

                      <CardContent sx={{ paddingLeft: { xs: 2, md: 3 } }}>
                        <Typography variant="h6">{post.title}</Typography>
                        <Typography variant="body2" color="text.secondary">
                          {post.description}
                        </Typography>
                      </CardContent>
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Typography
                  sx={{
                    width: "100%",
                    height: "70%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                >
                  New Blogs are on the way!
                </Typography>
              )}
            </Grid>
          </Grid>

          {/* Footer Section */}
          <Box
            sx={{
              mt: 2,
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              borderTop: "1px solid grey",
              pt: 2,
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Typography variant="body2">
              Ready to enhance your skills?{" "}
              <Link onClick={() => navigate("/admission")} underline="hover">
                Enroll Today
              </Link>
            </Typography>
            <Box>
              <Stack spacing={2} direction="row">
                <Button
                  variant="outlined"
                  sx={{ borderColor: "black", color: "black" }}
                  onClick={() => navigate("/about")}
                >
                  About
                </Button>
                <Button
                  variant="contained"
                  sx={{ bgcolor: "black", "&:hover": { bgcolor: "grey.800" } }}
                  onClick={() => navigate("/admission")}
                >
                  Enroll
                </Button>
              </Stack>
            </Box>
          </Box>
        </Box>
      </Popover>
    </AppBar>
  );
};

export default ResponsiveAppBar;
